import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

const StyledTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px;
  background-color: white;
  border-radius: 12px;
  margin-bottom: 32px;
`;

const StyledTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  font-weight: 500;
  font-family: 'Circular-Black';
`;

const StyledTableBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  max-height: ${props => props.height || '300px'};
`;

const StyledTableRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0px;
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
`;

const StyledTableCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: ${props => props.width || '0%'};
  text-align: ${props => props.textAlign || 'left'};
  font-family: ${props => props.fontFamily || 'Circular'};
  margin-right: ${props => props.marginRight || '0%'};
  color: 'black'};
`;

const StyledTableCellHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: ${props => props.width || '0%'};
  text-align: ${props => props.textAlign || 'left'};
  color: '#828282'};
`;

const BorderlessTable = ({ headers, data, tableHeight }) => {
  const formatCell = (data, format) => {
    if (format === 'date') {
      return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
    return data;
  };
  return (
    <StyledTableContainer>
      <StyledTableHeader>
        {headers.map(header => (
          <StyledTableCellHeader
            key={`table-header-${header.key}`}
            width={header.width}
            marginRight={header.marginRight}
          >
            {header.label}
          </StyledTableCellHeader>
        ))}
      </StyledTableHeader>
      <StyledTableBody height={tableHeight}>
        {data.map(item => (
          <StyledTableRow>
            {headers.map(header => (
              <StyledTableCell
                width={header.width}
                fontFamily={header.family}
                marginRight={header.marginRight}
              >
                {formatCell(item[header.key], header.format)}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        ))}
      </StyledTableBody>
    </StyledTableContainer>
  );
};

export default BorderlessTable;
